import React from 'react';
import PropTypes from 'prop-types';

import { t } from '../../../../../modules/infra/i18n';
import RoleAwareLink from '../../../../common/RoleAwareLink';
import Tooltip from '../../../../common/tooltip';
import SimpleHeader from '../../../../main/headers/simpleHeader';
import Input from '../../../../common/input';
import Select from '../../../../common/select';
import { mapSelectAddressOptions } from '../helpers';
import { poLocationAddressList } from '../shapes';

const EditLocation = ({
  busy,
  canEditProducts,
  handleSubmit,
  addressList,
}) => {
  const addressOptions = addressList.map(mapSelectAddressOptions);

  return (
    <form onSubmit={handleSubmit}>
      <SimpleHeader heading={t('products:edit_location.page_heading')}>
        <div className="o-flexbox o-flexbox--content-align-center u-pr-">
          <RoleAwareLink
            className="c-btn c-btn--white c-btn--medium u-mr u-width-85"
            to="/products/purchase-orders/locations"
          >
            {t('common:buttons.cancel')}
          </RoleAwareLink>
          <button
            type="submit"
            className="c-btn c-btn--medium u-width-85"
            display-if={canEditProducts}
            disabled={busy}
          >
            {t('common:save')}
          </button>
        </div>
      </SimpleHeader>

      <div className="c-wrapper">
        <div className="u-max-width-600 u-color-white u-border-radius-8 u-p">
          <h2 className="c-heading u-mb-">{t('products:edit_location.location_details_heading')}</h2>
          <fieldset disabled={busy}>
            <div className="layout">
              <div className="layout__item u-1/1">
                <span className="c-label-new">{t('products:edit_location.location_name_label')}</span>
                <Input
                  className="c-input c-input--border c-input--v3"
                  name="name"
                  type="text"
                  disabled
                />
              </div>
              <div className="layout__item u-1/2">
                <div className="o-flexbox o-flexbox--justify-start o-flexbox--content-align-center u-mb--">
                  <span className="c-label-new u-mb0">{t('products:edit_location.po_prefix_label')}</span>
                  <Tooltip>
                    {t('products:edit_location.po_prefix_tooltip')}
                  </Tooltip>
                </div>
                <Input
                  className="c-input c-input--border c-input--v3"
                  disabled={!canEditProducts}
                  name="prefix"
                  type="text"
                  maxLength="6"
                  placeholder={t('products:edit_location.po_prefix_placeholder')}
                />
              </div>
              <div className="layout__item u-1/2">
                <div className="o-flexbox o-flexbox--justify-start o-flexbox--content-align-center u-mb--">
                  <span className="c-label-new u-mb0">{t('products:edit_location.po_starting_number_label')}</span>
                  <Tooltip>
                    {t('products:edit_location.po_starting_number_tooltip')}
                  </Tooltip>
                </div>
                <Input
                  className="c-input c-input--border c-input--v3"
                  disabled={!canEditProducts}
                  name="startingPONumber"
                  type="number"
                  placeholder={t('products:edit_location.po_starting_number_placeholder')}
                />
              </div>
              <div className="layout__item u-1/1">
                <div className="o-flexbox o-flexbox--justify-start o-flexbox--content-align-center u-mb--">
                  <span className="c-label-new u-mb0">{t('products:edit_location.bill_to_address_label')}</span>
                  <Tooltip>
                    {t('products:edit_location.bill_to_address_tooltip')}
                  </Tooltip>
                </div>
                <Select
                  className="c-select"
                  disabled={!canEditProducts}
                  name="billingAddressId"
                  options={addressOptions}
                  parse={val => val || null}
                  empty
                />
              </div>
            </div>
          </fieldset>
        </div>
      </div>
    </form>
  );
};

EditLocation.propTypes = {
  addressList: poLocationAddressList.isRequired,
  busy: PropTypes.bool.isRequired,
  canEditProducts: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default EditLocation;
